import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_TRANSPORT_ID_LOADING = 'GET_TRANSPORT_ID_LOADING';
export const GET_TRANSPORT_ID_SUCCESS = 'GET_TRANSPORT_ID_SUCCESS';
export const GET_TRANSPORT_ID_REJECT = 'GET_TRANSPORT_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getTransportIdLoading = () => ({ type: GET_TRANSPORT_ID_LOADING });
export const getTransportIdSuccess = (payload) => ({ type: GET_TRANSPORT_ID_SUCCESS, payload });
export const getTransportIdReject = (payload) => ({ type: GET_TRANSPORT_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getTransportIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/Providers/Transports/${id}/edit`, options);
};